/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { FileSharesLocal } from './components';

export const BackupJobsFileSharesLocalPage: React.FC<{}> = () => (
    <TabBarBodyLayout>
        <FileSharesLocal />
    </TabBarBodyLayout>
);
